import {
  titleUI,
  descriptionUI,
} from 'platform/forms-system/src/js/web-component-patterns';

import {
  otherPaymentOptionsTitle,
  OtherPaymentOptionsDescription,
} from '../../components/additionalInformation/OtherPaymentOptions';

export default {
  uiSchema: {
    ...titleUI(otherPaymentOptionsTitle),
    ...descriptionUI(OtherPaymentOptionsDescription),
  },
  schema: {
    type: 'object',
    properties: {},
  },
};
